import { useSelector } from "react-redux";

import { useTemplateGroupActions } from "store/TemplateGroupSlice";

const useTemplateGroup = () => {
  const {
    loadTemplateGroup,
    loadTemplateGroupFromContentful,
    clearTemplateGroup,
    loadRecommendedTemplatesGroup,
    clearRecommendedTemplatesGroup,
  } = useTemplateGroupActions();

  const { templateGroup, recommended } = useSelector((state) => state.TemplateGroupSlice);

  return {
    loadTemplateGroup,
    loadTemplateGroupFromContentful,
    clearTemplateGroup,
    templateGroup,
    recommended,
    loadRecommendedTemplatesGroup,
    clearRecommendedTemplatesGroup,
  };
};

export default useTemplateGroup;
